// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schedule-create{overflow-y:scroll}.schedule-create .back-link{background:#fff;padding:5px 10px;margin-top:-5px;margin-right:-10px}.schedule-create__actions{width:100%;padding:20px 71px 0;bottom:0;position:fixed;text-align:right;background:#fff}", ""]);
// Exports
module.exports = exports;
